export enum Shift {
  DAYS = 'DAYS',
  AFTERNOONS = 'AFTERNOONS',
  NIGHTS = 'NIGHTS',
  OTHER = 'OTHER'
}
